module.exports = __webpack_public_path__ + "img/ing2.87ba21ca.jpg";